import { render, staticRenderFns } from "./BranchDetailTabs.vue?vue&type=template&id=430ed5d4&"
import script from "./BranchDetailTabs.vue?vue&type=script&lang=js&"
export * from "./BranchDetailTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports